// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/Themed';
import appColors from '@/theme/colors';
import { caption, sectionLabel } from '../../typography';

type Props = {
  title: string;
  count?: number;
  /** Optional explanatory line under the title. */
  hint?: string;
};

export default function SectionHeading({ title, count, hint }: Props) {
  return (
    <View style={styles.wrapper}>
      <View style={styles.row}>
        <Text style={styles.title}>{title}</Text>
        {typeof count === 'number' && (
          <View style={styles.badge}>
            <Text style={styles.badgeText}>{count}</Text>
          </View>
        )}
      </View>
      {hint ? <Text style={styles.hint}>{hint}</Text> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    gap: 4,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  title: sectionLabel,
  hint: caption,
  badge: {
    backgroundColor: appColors.accent.subtleBg,
    borderWidth: 1,
    borderColor: appColors.accent.subtleBorder,
    borderRadius: 10,
    paddingHorizontal: 8,
    paddingVertical: 2,
    minWidth: 24,
    alignItems: 'center',
  },
  badgeText: {
    fontSize: 12,
    fontWeight: '800',
    letterSpacing: 0.4,
    color: appColors.accent.primary,
  },
});
